import React, { useEffect, useState } from "react";
import SelectOption from "./SelectOption";
import { useFormik } from "formik";
import PrimaryButton from "../PrimaryButton";
import { categorySchema } from "../../../utils/validationSchemas";
import { useDispatch, useSelector } from "react-redux";
import { createOffer } from "../../../services/offerService";
import GreyButton from "../GreyButton";
import { useNavigate } from "react-router-dom";

const CategorySelection = ({
  setSubCategories,
  stepIndex,
  setStepIndex,
  categoryId,
  setCategoryId,
  setPayloadData,
  categories,
  editOfferData,
  isEdit,
  selectedMerchant,
  handlePrevious,
  showPreviousButton = true,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(
    editOfferData?.category || undefined
  );
  const loading = useSelector((state) => state?.offerReducer?.loading);
  const offerData = useSelector((state) => state?.offerReducer?.createdOffer);
  const [payload, setPayload] = useState(null);

  const formik = useFormik({
    initialValues: {
      category: editOfferData?.category?.title || "",
    },
    validationSchema: categorySchema,
    onSubmit: async (values) => {
      console.log(payload, "payload1234567890");
      if (payload !== null || (isEdit && editOfferData?.category)) {
        // Build a local payload to avoid relying on async state updates
        const effectivePayload = payload !== null ? payload : {
          category: editOfferData.category._id,
          merchantId: selectedMerchant?._id,
          id: editOfferData._id,
          offerId: editOfferData._id,
          isCreated: false,
        };

        const createPromise = await dispatch(createOffer(effectivePayload))?.unwrap();
        if (createPromise?.success === true) {
          setStepIndex(stepIndex + 1);
        }
      }
    },
  });

  useEffect(() => {
    if (editOfferData?.category) {
      // Set initial state for edit mode
      setSelectedCategory(editOfferData.category);
      formik.setFieldValue("category", editOfferData.category.title);
      setCategoryId(editOfferData.category._id);
      setSubCategories(editOfferData.category.subCategory || []);
    }
  }, [editOfferData]);

  useEffect(() => {
    if (categoryId == undefined && editOfferData !== null) {
      handleClick(editOfferData?.category?._id);
    } else if (offerData !== null) {
      handleClick(offerData?.category?._id);
    }
  }, [categories, offerData, editOfferData]);

  useEffect(() => {
    setPayloadData(payload);
  }, [payload]);

  const handleClick = async (id) => {
    if (id !== undefined) {
      const cate = categories?.find((cat) => cat?._id === id);
      if (cate) {
        setSelectedCategory(cate);
        const approvedSubCategories = cate?.subCategory;
        setSubCategories(approvedSubCategories);
        setFieldValue("category", cate?.title);
        setCategoryId(cate?._id);

        const newPayload = {
          merchantId: selectedMerchant?._id,
          category: id,
          isCreated: false,
        };

        if (editOfferData?._id) {
          newPayload.id = editOfferData._id;
          newPayload.offerId = editOfferData._id;
          if (editOfferData.category?._id !== id) {
            newPayload.subCategory = [];
          }
        } else if (offerData?._id) {
          newPayload.id = offerData._id;
          newPayload.offerId = offerData._id;
          if (categoryId !== id) {
            newPayload.subCategory = [];
          }
        }

        setPayload(newPayload);
      }
    }
  };

  const { category } = formik.values;
  const {
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    setValues,
  } = formik;

  const scrollToFirstError = (formErrors) => {
    const priority = ["category"]; // only field here
    let targetField = priority.find((key) => formErrors && Object.prototype.hasOwnProperty.call(formErrors, key));
    if (!targetField) {
      const keys = Object.keys(formErrors || {});
      targetField = keys.length ? keys[0] : null;
    }
    if (!targetField) return;
    let el = window.document.querySelector(`[data-field="${targetField}"]`) || window.document.querySelector(`[name="${targetField}"]`);
    if (el && typeof el.scrollIntoView === "function") {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      if (typeof el.focus === "function") {
        try { el.focus(); } catch (_) {}
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const attemptNext = async () => {
    const validationErrors = await formik.validateForm();
    if (Object.keys(validationErrors || {}).length > 0) {
      formik.setTouched(Object.keys(validationErrors).reduce((acc, k) => { acc[k] = true; return acc; }, {}), true);
      scrollToFirstError(validationErrors);
      return;
    }
    handleSubmit();
  };

  const isCategoryClicked = (cat) => {
    return selectedCategory?._id === cat?._id;
  };

  const isNextButtonBusy = Boolean(loading);
  const isNextButtonDisabled = isNextButtonBusy || !selectedCategory || !category;
  const nextButtonLabel = isNextButtonBusy ? (
    <span className="flex items-center justify-center gap-2">
      <span className="offer-btn-spinner" />
      <span>Processing...</span>
    </span>
  ) : (
    "Next"
  );

  return (
    <div className="w-full flex flex-col items-center justify-center mt-20">
      <div className="sm:w-[100%] md:w-[80%] lg:w-[70%] xl:w-[55%]">
        <p className="font-poppins font-[500] sm:text-[12px] md:text-[14px] lg:text-[16px] text-[#303030]">
          Which Category Best Describes your offer?
        </p>
        <p className="font-poppins font-[400] sm:text-[10px] md:text-[12px] text-[#767676]">
          Choose the perfect fit for your service
        </p>
        <div className="mt-5" data-field="category">
          {categories?.length > 0 &&
            categories?.map((cat) => (
              <SelectOption
                clicked={isCategoryClicked(cat)}
                icon={process.env.REACT_APP_ICON_URL + cat?.image}
                title={cat?.title}
                handleClick={() => handleClick(cat?._id)}
                postIcon={null}
                greyIcon={true}
              />
            ))}
        </div>
        {errors?.category && touched?.category ? (
          <span className="text-red-600 sm:text-[10px] md:text-[12px] font-[600] ms-1 mt-1">
            Category is required.
          </span>
        ) : null}
        <div className="w-full text-end mt-20">
          {showPreviousButton && (
            <GreyButton
              className="w-[40%] lg:w-[25%] h-[45px] rounded-[5px] text-[16px] font-[500] font-montserrat"
              label="Previous"
              onClick={handlePrevious}
            />
          )}
          <PrimaryButton
            className={
              "w-[40%] lg:w-[25%] h-[45px] rounded-[5px] text-[16px] font-[500] font-montserrat ms-2"
            }
            label={nextButtonLabel}
            disabled={isNextButtonDisabled}
            onClick={attemptNext}
          />
        </div>
      </div>
    </div>
  );
};

export default CategorySelection;
